import * as actionTypes from "constants/actionTypes";

export function createAudienceSegment(name, description, conditions) {
  return {
    type: actionTypes.CREATE_AUDIENCE_SEGMENT,
    payload: {
      name,
      description,
      conditions
    }
  };
}

export function createSegmentFromRule(name, stepId) {
  return {
    type: actionTypes.CREATE_SEGMENT_FROM_RULE,
    payload: {
      name,
      stepId
    }
  };
}

export function updateSegmentInStore(segmentId, changes) {
  return {
    type: actionTypes.UPDATE_SEGMENT_IN_STORE,
    payload: { segmentId, changes }
  };
}

export function updateSegmentAndFlushSegment(segmentId, changes) {
  return {
    type: actionTypes.UPDATE_SEGMENT_AND_FLUSH_SEGMENT,
    payload: {
      segmentId,
      changes
    }
  };
}

export function deleteSegmentInStore(segmentId) {
  return {
    type: actionTypes.DELETE_SEGMENT_IN_STORE,
    payload: { segmentId }
  };
}

export function deleteSegmentAndFlushSegment(segmentId) {
  return {
    type: actionTypes.DELETE_SEGMENT_AND_FLUSH_SEGMENT,
    payload: {
      segmentId
    }
  };
}

export function cloneSegment(segmentId) {
  return {
    type: actionTypes.CLONE_SEGMENT,
    payload: {
      segmentId
    }
  };
}

export function replaceAccountSegment(segmentId, segment) {
  return {
    type: actionTypes.REPLACE_ACCOUNT_SEGMENT,
    payload: { segmentId, segment }
  };
}

export function replaceAccountSegments(segments) {
  return {
    type: actionTypes.REPLACE_ACCOUNT_SEGMENTS,
    payload: segments
  };
}
